// extracted by mini-css-extract-plugin
module.exports = {"brandBox":"brand_brandBox__1u6Jb","all":"brand_all__33wgW","brandName":"brand_brandName__3OoYB"};